export default __webpack_public_path__ + "static/media/yoga.253a36fb.png";